import { render, staticRenderFns } from "./HorizontalBtnNav.vue?vue&type=template&id=6e4c3b70&scoped=true&"
import script from "./HorizontalBtnNav.vue?vue&type=script&lang=ts&"
export * from "./HorizontalBtnNav.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalBtnNav.vue?vue&type=style&index=0&id=6e4c3b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c3b70",
  null
  
)

export default component.exports